import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

// Import all pages without lazy loading
import Home from "./pages/Home";
import Groepenkast from "./pages/Groepenkast";
import Elektraaanleg from "./pages/ElektraAanleggen";
import KookgroepAansluiten from "./pages/KookgroepAansluiten";
import ElektraRenovatie from "./pages/ElektraRenovatie";
import DriesFaseAansluiting from "./pages/DriesFaseAansluiting";
import Laadpaal from "./pages/Laadpaal";
import Zonnepanelen from "./pages/Zonnepanelen";
import Klantenservice from "./pages/Klantenservice";
import OnsVerhaal from "./pages/OnsVerhaal";
import Begrippen from "./pages/Begrippen";
import Vacatures from "./pages/Vacatures";
import Term from "./pages/Term";
import Offerte from "./pages/Offerte";
import Privacy from "./pages/Privacy";
import VeelgesteldeVragen from "./pages/Veelgestelde-vragen";
import Voorwaarden from "./pages/Voorwaarden";
import Cookies from "./pages/Cookies";
import NotFound from "./pages/NotFound";
import Contact from "./pages/Contact";
import ThankYou from "./pages/Thankyou";
import StopcontactenPlaatsen from "./pages/StopcontactPlaatsen";
import Sitemap from "./pages/Sitemap";
import InspectiePagina from "./pages/Inspectie";
import RegioDetail from "./pages/RegioDetail";
import Regios from "./pages/Regios";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/offerte" element={<Offerte />} />
        <Route path="/groepenkast-vervangen" element={<Groepenkast />} />
        <Route path="/elektra-aanleggen" element={<Elektraaanleg />} />
        <Route path="/kookgroep-aansluiten" element={<KookgroepAansluiten />} />
        <Route path="/elektra-renovatie" element={<ElektraRenovatie />} />
        <Route path="/3-fase-aansluiting" element={<DriesFaseAansluiting />} />
        <Route path="/laadpaal" element={<Laadpaal />} />
        <Route path="/zonnepanelen" element={<Zonnepanelen />} />
        <Route path="/klantenservice" element={<Klantenservice />} />
        <Route path="/ons-verhaal" element={<OnsVerhaal />} />
        <Route path="/vacatures" element={<Vacatures />} />
        <Route path="/begrippen" element={<Begrippen />} />
        <Route path="/inspectie" element={<InspectiePagina />} />
        <Route path="/begrippen/:slug" element={<Term />} />
        <Route path="/regios" element={<Regios />} />
        <Route path="/regios/:city" element={<RegioDetail />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/veelgestelde-vragen" element={<VeelgesteldeVragen />} />
        <Route path="/voorwaarden" element={<Voorwaarden />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/stopcontacten-plaatsen" element={<StopcontactenPlaatsen />} />
        <Route path="/bedankt-offerte" element={<ThankYou />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
